import * as t from "io-ts";
import nullable from "./nullable";
export const getEconomicClientResponseT = t.strict({
    name: t.string,
    cvrNumber: nullable(t.string),
    address: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
    country: nullable(t.string),
    email: nullable(t.string),
    phoneNumberMobile: nullable(t.string),
    clientNumber: t.string,
    customerGroupNumber: nullable(t.number),
    visibleToDrivers: t.boolean,
});
export const ECONOMIC_CUSTOMER_NOT_FOUND = "ECONOMIC_CUSTOMER_NOT_FOUND";
export const economicCustomerNotFoundErrorT = t.strict({
    code: t.literal(ECONOMIC_CUSTOMER_NOT_FOUND),
    message: t.string,
    params: t.strict({ clientNumber: t.string }),
});
export const clientT = t.strict({
    id: t.string,
    name: t.string,
    number: t.string,
    showArrivalDepartureToDriver: nullable(t.boolean),
    showAddCubicMetersToDriver: nullable(t.boolean),
});
export const clientsT = t.array(clientT);
export const getBusinessCentralClientResponseT = t.strict({
    name: nullable(t.string),
    organizationNumber: nullable(t.string),
    address: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
    email: nullable(t.string),
    phoneNumberMobile: nullable(t.string),
    visibleToDrivers: t.boolean,
});
export const updateBusinessCentralClientT = t.strict({
    name: t.string,
    organizationNumber: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    email: t.string,
    phoneNumberMobile: t.string,
});
export const updateEconomicClientT = t.strict({
    name: t.string,
    cvrNumber: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    country: t.string,
    email: t.string,
    phoneNumberMobile: t.string,
    customerGroupNumber: t.number,
});
export const addEconomicClientT = t.strict({
    clientNumber: t.string,
    name: t.string,
    cvrNumber: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    country: t.string,
    email: t.string,
    phoneNumberMobile: t.string,
    visibleToDrivers: t.boolean,
    customerGroupNumber: t.number,
});
export const addBusinessCentralClientT = t.strict({
    name: t.string,
    email: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    organizationNumber: t.string,
    phoneNumberMobile: t.string,
    visibleToDrivers: t.boolean,
});
export const addTripletexClientT = t.strict({
    name: t.string,
    email: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    organizationNumber: t.string,
    phoneNumberMobile: t.string,
    visibleToDrivers: t.boolean,
});
export const getTripletexClientResponseT = t.strict({
    name: nullable(t.string),
    organizationNumber: nullable(t.string),
    address: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
    email: nullable(t.string),
    phoneNumberMobile: nullable(t.string),
    visibleToDrivers: t.boolean,
});
export const updateTripletexClientT = t.strict({
    name: t.string,
    email: t.string,
    address: t.string,
    postcode: t.string,
    city: t.string,
    organizationNumber: t.string,
    phoneNumberMobile: t.string,
});
export const addPowerOfficeClientT = t.strict({
    name: t.string,
    email: t.string,
    address: t.string,
    postcode: t.string,
    city: nullable(t.string),
    organizationNumber: t.string,
    phoneNumberMobile: nullable(t.string),
    clientNumber: t.number,
    visibleToDrivers: t.boolean,
});
export const getPowerOfficeClientResponseT = t.strict({
    name: nullable(t.string),
    organizationNumber: nullable(t.string),
    address: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
    email: nullable(t.string),
    phoneNumberMobile: nullable(t.string),
    visibleToDrivers: t.boolean,
});
export const updatePowerOfficeClientT = t.strict({
    name: t.string,
    organizationNumber: t.string,
    address: t.string,
    postcode: t.string,
    city: nullable(t.string),
    email: t.string,
    phoneNumberMobile: nullable(t.string),
});
export const dispatchingClientT = t.strict({
    id: t.string,
    client: t.string,
    clientNumber: t.string,
    clientPhone: nullable(t.string),
    clientEmail: nullable(t.string),
    clientAddress: nullable(t.string),
    visibleToDrivers: t.boolean,
    applicableSurchargesIds: t.array(t.string),
    individualInvoiceTemplateId: nullable(t.string),
    consolidatedInvoiceTemplateId: nullable(t.string),
    showArrivalDepartureToDriver: nullable(t.boolean),
    showAddCubicMetersToDriver: nullable(t.boolean),
    consolidatedInvoicesGroupSurcharges: t.boolean,
    consolidatedInvoicesGroupProducts: t.boolean,
    shipmentDriverReportTemplateId: nullable(t.string),
    webBookerAllowApiAccess: t.boolean,
    webBookerCanSeeOrdersDelivered: t.boolean,
});
export const dispatchingClientsT = t.array(dispatchingClientT);
export const clientsRemovedT = t.strict({ ids: t.array(t.string) });
//# sourceMappingURL=client.js.map